import { Cancel, Check, Edit } from "@mui/icons-material";
import { TextareaAutosize } from "@mui/material";
import { CellContext } from "@tanstack/react-table";
import LoadingSpinner from "components/LoadingSpinner";
import { TagView } from "generated/graphql";
import { TagColumnMeta } from "./types";
import { useState } from "react";
import { stripNull } from "helpers/coll";
import { cn } from "components/lib/utils";

export function TagDescription({ row: { original }, column }: CellContext<TagView, string>) {
  const [tag, setTag] = useState(original);
  const [checkpoint, setCheckpoint] = useState(tag);
  const [editing, setEditing] = useState(false);
  const [pending, setPending] = useState(false);
  const onSave = async () => {
    setPending(true);
    try {
      await (column.columnDef.meta as TagColumnMeta)?.onSave(tag);
      setCheckpoint(tag);
    } finally {
      setEditing(false);
      setPending(false);
    }
  };
  const onEdit = async () => {
    setEditing(true);
    setCheckpoint(tag);
  };
  const onCancel = async () => {
    setEditing(false);
    setTag(checkpoint);
  };

  return (
    <span className="w-full justify-between inline-flex items-center gap-1" onClick={() => !editing && onEdit()}>
      {editing ? (
        <TextareaAutosize
          autoFocus
          minRows={1}
          maxRows={5}
          className="w-full bg-white p-0 focus:ring-peri-300"
          value={tag.description ?? ""}
          onChange={(e) => setTag((t) => ({ ...t, description: e.target.value }))}
        />
      ) : (
        <span
          className={cn(
            "py-1 whitespace-pre-wrap",
            stripNull(tag.description) === undefined ? "text-gray-100 italic" : ""
          )}
          onClick={onEdit}>
          {tag.description ?? "Enter description"}
        </span>
      )}
      <div className="flex items-center gap-1">
        {pending && <LoadingSpinner size={16} />}
        {!pending &&
          (!editing ? (
            <Edit tabIndex={0} className="h-4 w-4 opacity-50 cursor-pointer" onClick={onEdit} />
          ) : (
            <>
              <Cancel tabIndex={0} className="h-4 w-4 opacity-50 cursor-pointer" onClick={onCancel} />
              <Check tabIndex={0} className="h-4 w-4 opacity-50 cursor-pointer" onClick={onSave} />
            </>
          ))}
      </div>
    </span>
  );
}
